import axios from "axios"
import Element from 'element-ui'
import config from "@/utils/config"
const base_url = config.context;
// 封装的下载接口
export function downLoadDocument(url1, name) {
  return axios({
    method: 'get',
    url: `${window.location.protocol}//${window.location.hostname}:8081` + url1,
    responseType: 'blob'
  }).then((res) => {
    if ('download' in document.createElement('a')) {
      let url = window.URL.createObjectURL(res.data);
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      navigator.msSaveBlob(res.data, name)
    }
  }).catch(err => {
    Element.Message('下载失败')
  })
}


// 封装的下载接口
export function downLoadNewument(url1, name) {
  return axios({
    method: 'get',
    url: base_url + url1,
    responseType: 'blob'
  }).then((res) => {
    if ('download' in document.createElement('a')) {
      let url = window.URL.createObjectURL(res.data);
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      navigator.msSaveBlob(res.data, name)
    }
  }).catch(err => {
    Element.Message('下载失败')
  })
}
